<template>
    <div id="app">
        <router-view :key="$route.path"></router-view>
        <div class="backBtn" @click="backBtn()" v-if="back" title="返回上一页"><i class="el-icon-back"></i></div>
        <div class="backBtn backTop" @click="backTopBtn()" v-if="backTop" title="返回顶部"><i class="el-icon-top"></i></div>
    </div>
</template>

<script>

export default {
    name: 'App',
    data () {
        return {
            back:true,
            backTop:false
        }
    },
    methods:{
        backBtn(){
            this.$router.go(-1);
        },
        backTopBtn(){
            document.documentElement.scrollTop = 0;
        }
    },
    created() {

        let href = window.location.hash;
        this.back = href.indexOf('index') === -1;

        window.onscroll = ()=>{
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            this.backTop = top > 200;
        }

    },
    updated() {
        let href = window.location.hash;
        this.back = href.indexOf('index') === -1;
    }
}
</script>

<style>
    .backBtn{
        width: 3rem;
        height: 3rem;
        position: fixed;
        bottom: 4rem;
        right: 2rem;
        background: #171717;
        color: #ffffff;
        border-radius: 3rem;
        text-align: center;
        line-height: 3.2rem;
        font-size: 2rem;
        cursor: pointer;
        opacity: 0.5;
    }
    .backBtn:hover{
        background: #292929;
        opacity: 0.8;
    }
    .backTop{
        bottom: 8rem;
        right: 2rem;
    }
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    body{
        margin: 0;
    }
    html{
        font-size: 16px;
    }

    .contBox{
        width: 85.5rem;
        height: auto;
        overflow: hidden;
        margin:  0 auto;
    }
    .el-header{
        padding: 0;
        height: auto !important;
    }
    .footer{
        width: 100%;
        height: 7.0625rem !important;
        background: #171717;
        padding: 0 !important;
        overflow: hidden;
    }
</style>
